
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 1.833c.368 0 .667.299.667.667v.667h2.666V2.5a.667.667 0 011.334 0v.667h2c.736 0 1.333.597 1.333 1.333v8.667c0 .736-.597 1.333-1.333 1.333H3.333A1.333 1.333 0 012 13.167V4.5c0-.736.597-1.333 1.333-1.333h2V2.5c0-.368.299-.667.667-.667zM5.333 4.5h-2v2h9.334v-2h-2v.667a.667.667 0 01-1.334 0V4.5H6.667v.667a.667.667 0 01-1.334 0V4.5zm7.334 3.333H3.333v5.334h9.334V7.833z","fill":"#A0AEC0"}})])
          )
        }
      }
    